import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const FiltersStep = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });

  // TODO: [SP-11833] replace placeholder with the Filters step
  return <Typography variant="bodyRegular">{t("stepPlaceholder", { name: t("steps.filters") })}</Typography>;
};
